// import React from 'react';
// import AppBaseComponent from '../../../../components/AppBaseComponent';
// import {connect} from "react-redux";
// import tapIcon from "../../../../services/TapIcon";
// import TransactionSetting from './TransactionSetting';
// import GeneralSettings from './GeneralSettings';
// import Workflow from './Workflow';
// import TermCondition from '../quotationConfiguration/TermCondition';
// import AdditionalAttribute from '../../AdditionalAttribute';
// import TagComponent from '../../TagComponent';



// class SalesOrderConfiguration extends AppBaseComponent {

//     constructor(props) {
//         super(props);


//         this.state                          =        {
//            enableTransactionId                 :       'Y',
//         } 
//     }

//     render() {

//         return (
//             <section className="page_containt " style={{ top: "1px" }}>
//                 <div className="pageTbl bg-white">
//                     <ul className="nav nav-tabs" id="myTab" role="tablist">
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link  active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
//                                 type="button" role="tab" aria-controls="details" aria-selected="true">General
//                             </button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link " id="workflow-tab" data-bs-toggle="tab" data-bs-target="#workflow"
//                                 type="button" role="tab" aria-controls="workflow" aria-selected="true">Workflow
//                             </button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link " id="terms-tab" data-bs-toggle="tab" data-bs-target="#terms"
//                                 type="button" role="tab" aria-controls="terms" aria-selected="true">Terms & Condition
//                             </button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link " id="attribute-tab" data-bs-toggle="tab" data-bs-target="#attribute"
//                                 type="button" role="tab" aria-controls="attribute" aria-selected="true">Addititonal Attribute
//                             </button>
//                         </li>
//                         <li className="nav-item" role="presentation">
//                             <button className="nav-link " id="tags-tab" data-bs-toggle="tab" data-bs-target="#tags" type="button" role="tab" aria-controls="tags" aria-selected="true">Tags
//                             </button>
//                         </li>
//                     </ul>
//                     <div className="tab-content" id="myTabContent">

//                         <div className="tab-pane show active" id="details" role="tabpanel"
//                             aria-labelledby="details-tab">
//                             <div className="tab_content_header">
//                              <TransactionSetting/>
//                             <GeneralSettings/>
                                
//                             </div>
//                         </div>
//                         <div className="tab-pane" id="workflow" role="tabpanel"  aria-labelledby="workflow-tab">
//                             <div className="tab_content_header">
//                                  <Workflow/> 
//                             </div>
//                         </div>
//                         <div className="tab-pane" id="terms" role="tabpanel"
//                             aria-labelledby="terms-tab">
//                             <div className="tab_content_header">
//                                 <TermCondition salesOrderKey="sales_order"/>
//                             </div>
//                         </div>
//                         <div className="tab-pane" id="attribute" role="tabpanel"
//                             aria-labelledby="attribute-tab">
//                             <div className="tab_content_header">
//                                 <AdditionalAttribute category="sales_order"/>
//                             </div>
//                         </div>
//                         <div className="tab-pane" id="tags" role="tabpanel" aria-labelledby="tags-tab">
//                             <div className="tab_content_header"><TagComponent type="sales_order"/></div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         )
//     }
// }

// const mapStateToProps = state => {
//     return {
//         access_token            :        state.auth.access_token
//     };
// };

// export default connect(mapStateToProps)(SalesOrderConfiguration);

import React from 'react';
import AppBaseComponent from '../../../../components/AppBaseComponent';
import {connect} from "react-redux";
import tapIcon from "../../../../services/TapIcon";
import TransactionSetting from './TransactionSetting';
import GeneralSettings from './GeneralSettings';
import Workflow from './Workflow';
import TermCondition from '../quotationConfiguration/TermCondition';
import AdditionalAttribute from '../../AdditionalAttribute';
import TagComponent from '../../TagComponent';

class SalesOrderConfiguration extends AppBaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'details',
            // Track which tabs have been loaded
            loadedTabs: {
                details: true, // Initially loaded
                workflow: false,
                terms: false,
                attribute: false,
                tags: false
            }
        }
    }

    // Handle tab switching
    handleTabSwitch = (tabId) => {
        this.setState({
            activeTab: tabId,
            loadedTabs: {
                ...this.state.loadedTabs,
                [tabId]: true
            }
        });
    }

    render() {
        const { activeTab, loadedTabs } = this.state;

        return (
            <section className="page_containt " style={{ top: "1px" }}>
                <div className="pageTbl bg-white">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button 
                                className={`nav-link ${activeTab === 'details' ? 'active' : ''}`}
                                id="details-tab" 
                                data-bs-toggle="tab" 
                                data-bs-target="#details"
                                type="button" 
                                role="tab" 
                                aria-controls="details" 
                                aria-selected={activeTab === 'details'}
                                onClick={() => this.handleTabSwitch('details')}
                            >
                                General
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button 
                                className={`nav-link ${activeTab === 'workflow' ? 'active' : ''}`}
                                id="workflow-tab" 
                                data-bs-toggle="tab" 
                                data-bs-target="#workflow"
                                type="button" 
                                role="tab" 
                                aria-controls="workflow" 
                                aria-selected={activeTab === 'workflow'}
                                onClick={() => this.handleTabSwitch('workflow')}
                            >
                                Workflow
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button 
                                className={`nav-link ${activeTab === 'terms' ? 'active' : ''}`}
                                id="terms-tab" 
                                data-bs-toggle="tab" 
                                data-bs-target="#terms"
                                type="button" 
                                role="tab" 
                                aria-controls="terms" 
                                aria-selected={activeTab === 'terms'}
                                onClick={() => this.handleTabSwitch('terms')}
                            >
                                Terms & Condition
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button 
                                className={`nav-link ${activeTab === 'attribute' ? 'active' : ''}`}
                                id="attribute-tab" 
                                data-bs-toggle="tab" 
                                data-bs-target="#attribute"
                                type="button" 
                                role="tab" 
                                aria-controls="attribute" 
                                aria-selected={activeTab === 'attribute'}
                                onClick={() => this.handleTabSwitch('attribute')}
                            >
                                Additional Attribute
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button 
                                className={`nav-link ${activeTab === 'tags' ? 'active' : ''}`}
                                id="tags-tab" 
                                data-bs-toggle="tab" 
                                data-bs-target="#tags" 
                                type="button" 
                                role="tab" 
                                aria-controls="tags" 
                                aria-selected={activeTab === 'tags'}
                                onClick={() => this.handleTabSwitch('tags')}
                            >
                                Tags
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className={`tab-pane ${activeTab === 'details' ? 'show active' : ''}`} 
                             id="details" role="tabpanel" aria-labelledby="details-tab">
                            <div className="tab_content_header">
                                <TransactionSetting loaded={loadedTabs.details} />
                                <GeneralSettings loaded={loadedTabs.details} />
                            </div>
                        </div>
                        <div className={`tab-pane ${activeTab === 'workflow' ? 'show active' : ''}`} 
                             id="workflow" role="tabpanel" aria-labelledby="workflow-tab">
                            <div className="tab_content_header">
                                <Workflow loaded={loadedTabs.workflow} />
                            </div>
                        </div>
                        <div className={`tab-pane ${activeTab === 'terms' ? 'show active' : ''}`} 
                             id="terms" role="tabpanel" aria-labelledby="terms-tab">
                            <div className="tab_content_header">
                                <TermCondition salesOrderKey="sales_order" loaded={loadedTabs.terms} />
                            </div>
                        </div>
                        <div className={`tab-pane ${activeTab === 'attribute' ? 'show active' : ''}`} 
                             id="attribute" role="tabpanel" aria-labelledby="attribute-tab">
                            <div className="tab_content_header">
                                <AdditionalAttribute category="sales_order" loaded={loadedTabs.attribute} />
                            </div>
                        </div>
                        <div className={`tab-pane ${activeTab === 'tags' ? 'show active' : ''}`} 
                             id="tags" role="tabpanel" aria-labelledby="tags-tab">
                            <div className="tab_content_header">
                                <TagComponent type="sales_order" loaded={loadedTabs.tags} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(SalesOrderConfiguration);